import dayjs from 'dayjs'
import { areDatesEqual } from 'helpers/date.util'
import { CensusFileRowGridData } from '../../types/census-file-row-grid-data'
import { EligibilityData } from '../../types/eligibility-data'

export const toEligibilityDate = (value: unknown): Date | null => {
  if (value == null) return null
  return dayjs.utc(new Date(value as string | Date)).toDate()
}

export const getResolvedEligibilityFromRow = (
  row: CensusFileRowGridData
): EligibilityData => {
  const saved = row.memberUpdates
  const original = row.updates

  return {
    benefitsEligible: Boolean(
      saved?.benefitsEligible ?? original?.benefitsEligible
    ),
    benefitsEffectiveDate: toEligibilityDate(
      saved?.benefitsEffectiveDate ?? original?.benefitsEffectiveDate
    ),
    enrollmentStartDate: toEligibilityDate(
      saved?.enrollmentStartDate ?? original?.enrollmentStartDate
    ),
    enrollmentEndDate: toEligibilityDate(
      saved?.enrollmentEndDate ?? original?.enrollmentEndDate
    ),
    doNotCreateEnrollment: Boolean(saved?.doNotCreateEnrollment),
  }
}

export const getEligibilityBaselineUpdatesFromRow = (
  row: CensusFileRowGridData
): EligibilityData => getResolvedEligibilityFromRow(row)

export const eligibilityFieldsDiffer = (
  current: EligibilityData,
  saved: EligibilityData
): boolean => {
  if (current.benefitsEligible !== saved.benefitsEligible) return true
  if (current.doNotCreateEnrollment !== saved.doNotCreateEnrollment) return true
  if (
    !areDatesEqual(current.benefitsEffectiveDate, saved.benefitsEffectiveDate)
  )
    return true
  if (!areDatesEqual(current.enrollmentStartDate, saved.enrollmentStartDate))
    return true
  if (!areDatesEqual(current.enrollmentEndDate, saved.enrollmentEndDate))
    return true
  return false
}

export const hasAnyUnsavedEligibilityChanges = (
  eligibilityData: Record<string, EligibilityData>,
  savedEligibilityByEmployeeId: Record<string, EligibilityData>
): boolean =>
  Object.entries(eligibilityData).some(([employeeId, current]) => {
    const saved = savedEligibilityByEmployeeId[employeeId]
    if (!saved) return false
    return eligibilityFieldsDiffer(current, saved)
  })
